// extracted by mini-css-extract-plugin
export default {"sortWay":"SortPage_sortWay__jPvqa","checked":"SortPage_checked__oiKwd","status":"SortPage_status__nY7xE","header":"SortPage_header__HJQ-J"};